var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}},{key:"item.refDesc",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"dont-break-out"},[_vm._v(_vm._s(item.refDesc))])]}},{key:"item.discipMainArtDesc",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"dont-break-out"},[_vm._v(_vm._s(item.discipMainArtDesc))])]}},{key:"item.discipSubArtDesc",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"dont-break-out"},[_vm._v(_vm._s(item.discipSubArtDesc))])]}},{key:"item.discipDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.discipDate)))])]}},{key:"item.noteExplDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.noteExplDate)))])]}},{key:"item.writExplDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.writExplDate)))])]}},{key:"item.hearingDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.hearingDate)))])]}},{key:"item.memoDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.memoDate)))])]}},{key:"item.suspendedFrom",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.suspendedFrom)))])]}},{key:"item.suspendedTo",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.suspendedTo)))])]}},{key:"item.receivedDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.receivedDate)))])]}},{key:"item.terminatedDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(item.terminatedDate)))])]}},{key:"item.attachment",fn:function(ref){
var item = ref.item;
return [_vm._t("attachment",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }